import type { Landmark } from '../../../data/types';

export function readNumber(
  params: Landmark['params'],
  key: string,
  fallback: number,
  warn: (msg: string) => void
): number {
  const value = params[key];
  if (value === undefined) return fallback;
  if (typeof value === 'number') return value;
  warn(`Landmark param '${key}' expected number, got ${typeof value}`);
  return fallback;
}

export function readBool(
  params: Landmark['params'],
  key: string,
  fallback: boolean,
  warn: (msg: string) => void
): boolean {
  const value = params[key];
  if (value === undefined) return fallback;
  if (typeof value === 'boolean') return value;
  warn(`Landmark param '${key}' expected boolean, got ${typeof value}`);
  return fallback;
}

export function readEnum<T extends string>(
  params: Landmark['params'],
  key: string,
  valid: readonly T[],
  fallback: T,
  warn: (msg: string) => void
): T {
  const value = params[key];
  if (value === undefined) return fallback;
  if (typeof value === 'string' && valid.includes(value as T)) {
    return value as T;
  }
  warn(`Landmark param '${key}' expected one of [${valid.join(', ')}], got ${value}`);
  return fallback;
}
